export enum LEGAL_DOCUMENT_TYPES {
  PRIVACY_POLICY = 'PRIVACY_POLICY',
  SCHOOL_RULES = 'SCHOOL_RULES',
  AI_PACT = 'AI_PACT',
  E_COM_PRIVACY_POLICY = 'E_COM_PRIVACY_POLICY',
  E_COM_SCHOOL_RULES = 'E_COM_SCHOOL_RULES',
  E_COM_AI_PACT = 'E_COM_AI_PACT',
}

/** Legal documents every student plan requires by default. */
export const DEFAULT_PLAN_LEGAL_DOCUMENT_TYPES = [
  LEGAL_DOCUMENT_TYPES.PRIVACY_POLICY,
  LEGAL_DOCUMENT_TYPES.SCHOOL_RULES,
  LEGAL_DOCUMENT_TYPES.AI_PACT,
];

/** Legal documents specific to e-commerce students. */
export const E_COM_LEGAL_DOCUMENT_TYPES = [
  LEGAL_DOCUMENT_TYPES.E_COM_PRIVACY_POLICY,
  LEGAL_DOCUMENT_TYPES.E_COM_SCHOOL_RULES,
  LEGAL_DOCUMENT_TYPES.E_COM_AI_PACT,
];

export enum LEGAL_DOCUMENTS_VERSION_TYPES {
  MAJOR = 'MAJOR',
  MINOR = 'MINOR',
}

/** Mongoose model metadata owned by the legal-document bounded context. */
export const LEGAL_DOCUMENT_MODEL = {
  MODEL_NAME: 'LegalDocument',
  COLLECTION_NAME: 'LegalDocuments',
} as const;
